var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIonic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1925",
    "data-name": "Rectangle 1925",
    width: 52,
    height: 52,
    transform: "translate(919 596)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_30",
    "data-name": "Mask Group 30",
    transform: "translate(-919 -596)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ionic_Logo",
    transform: "translate(921.001 598.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19776",
    "data-name": "Path 19776",
    d: "M19.945,26.565a11.08,11.08,0,1,0,11.08,11.08A11.08,11.08,0,0,0,19.945,26.565Z",
    transform: "translate(4.368 -13.326)",
    fill: "#478aff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 5.047,
    cy: 5.047,
    r: 5.047,
    transform: "translate(35.175 4.126)",
    fill: "#478aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19777",
    "data-name": "Path 19777",
    d: "M50.527,36.037l-.212-.463-.331.384a7.607,7.607,0,0,1-3.046,2.1l-.331.119.132.331a19.875,19.875,0,1,1-9.827-10.323l.311.149L37.359,28a7.607,7.607,0,0,1,2.243-2.94l.4-.331-.453-.235A24.039,24.039,0,0,0,28.4,21.785,24.314,24.314,0,1,0,50.523,36.007Z",
    transform: "translate(-4.089 -21.789)",
    fill: "#478aff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonic);
export default __webpack_public_path__ + "static/media/Ionic.9621e9eb24558bc6d33a1b951c57631d.svg";
export { ForwardRef as ReactComponent };